const genres = [
  "Action",
  "Adult",
  "Adventure",
  "Anime",
  "Children",
  "Comedy",
  "Crime",
  "DIY",
  "Drama",
  "Espionage",
  "Family",
  "Fantasy",
  "Food",
  "History",
  "Horror",
  "Legal",
  "Medical",
  "Music",
  "Mystery",
  "Nature",
  "Romance",
  "Science-Fiction",
  "Sports",
  "Supernatural",
  "Thriller",
  "Travel",
  "War",
  "Western",
];

export default genres;
